import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 3v14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 10h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 21h14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Diff";
const Diff = memo(themed(Icon));
export {
  Diff
};
//# sourceMappingURL=diff.js.map
